import React from 'react'
import Carousel from 'nuka-carousel'
import { VENEER_WHITE } from '../../../store/Constants'
import IconChevronLeft from '@veneer/core/dist/esm/scripts/icons/icon_chevron_left'
import IconChevronRight from '@veneer/core/dist/esm/scripts/icons/icon_chevron_right'
import { default as VeneerModal } from '@veneer/core/dist/esm/scripts/modal'
import PageHeader from '../../../components/PageHeader'
import Button from '@veneer/core/dist/scripts/button'

const CarouselPageModalView = ({
  classes,
  pageData,
  cards,
  instruction,
  show,
  totalCards,
  currentCard,
  setCurrentCard,
  setPreviousCard,
  onCloseModal = null,
  Dots = null
}) => {
  return (
    <VeneerModal
      className={classes.carouselModal}
      data-testid={`modal-carousel`}
      align="start"
      closeButton
      onClose={onCloseModal}
      show={show}
      maxWidth="890px"
      portal
    >
      <div className={classes.carousel}>
        <PageHeader
          className={classes.header}
          header={pageData.header}
          headerDataTestId={`instruction-modal-header-${instruction}`}
        />
        <div className={classes.container} dir="ltr">
          <Carousel
            renderCenterLeftControls={({ previousSlide, currentSlide }) => {
              return currentSlide > 0 ? (
                <Button
                  className={classes.prev}
                  data-testid="prev"
                  onClick={previousSlide}
                  style={{
                    width: '48px',
                    minWidth: '48px',
                    maxWidth: '48px'
                  }}
                >
                  <IconChevronLeft color={VENEER_WHITE} />
                </Button>
              ) : null
            }}
            renderCenterRightControls={({ nextSlide, currentSlide }) => {
              return currentSlide < totalCards - 1 ? (
                <Button
                  className={classes.next}
                  data-testid="next"
                  onClick={nextSlide}
                  style={{
                    width: '48px',
                    minWidth: '48px',
                    maxWidth: '48px'
                  }}
                >
                  <IconChevronRight color={VENEER_WHITE} />
                </Button>
              ) : null
            }}
            renderBottomCenterControls={false}
            beforeSlide={(previousSlideIndex, nextSlideIndex) => {
              setPreviousCard(previousSlideIndex)
              setCurrentCard(nextSlideIndex)
            }}
            slideIndex={currentCard}
            slidesToShow={1}
            className={classes.carouselComponent}
          >
            {cards}
          </Carousel>
        </div>
        {Dots}
      </div>
    </VeneerModal>
  )
}

export default CarouselPageModalView
